import React, { useContext, useRef, useState } from "react";
import { useEffect } from "react";
import Application from "../../components/application";
import Button from "@mui/material/Button";
import ListAltIcon from '@mui/icons-material/ListAlt';
import { useNavigate } from "react-router-dom";
import GridView from "../../components/views/gridView";
import {Box, Fab, Tooltip} from "@mui/material";
import FmdGoodIcon from '@mui/icons-material/FmdGood';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

import useTarefaState from "../../hooks/useTarefa";
import MyMapModal from "../../components/myMapModal";
import ModalFinalizaTarefa from "./modalFinalizaTarefa";
import TELAS from "../../constants/telas";
import { AuthContext } from "../../contexts/auth";
import MyCheckbox from "../../components/myCheckbox";
import MyInput from "../../components/myInput";
import SearchIcon from '@mui/icons-material/Search';
import TELA_ACOES from "../../constants/telaAcoes";
import permissaoTelas from "../../utils/permissaoTelas";
import PaginationGridView from "../../components/views/paginationGridView";


const PAGINA = {
    aplicacao: 'SisPalo - Tarefas',
    funcionalidade: 'Tarefas',
    tela: TELAS.TAREFAS,
    acoes: [TELA_ACOES.Finalizar,TELA_ACOES.Consultar, TELA_ACOES.Geolocalização]
}

const MyFiltro = ({label, checked ,onChange, states, onClick})=> {
    return (
        <Box sx={{display:'flex', flexDirection: 'column', width: '100%'}}>
            <Box sx={{display: 'flex', alignItems: 'center', gap: 1, width: '100%'}}>
                <Box sx={{display:'flex', flex:1,justifyContent: 'center',gap :1}}>
                    <MyInput
                    label="Data Inicial Período"
                    type="date"
                    size="small"
                    value={states.dataInicial.value}
                    onChange={(e) => states.dataInicial.set(e.target.value)}
                    />
                    <MyInput
                    label="Data Final Período"
                    type="date"
                    size="small"
                    value={states.dataFinal.value}
                    onChange={(e) => states.dataFinal.set(e.target.value)}
                    />                
                    <Tooltip title="Pesquisar" placement="bottom" arrow>
                        <Button onClick={onClick}><SearchIcon /></Button>
                    </Tooltip>                
                </Box>

                <Box sx={{ marginLeft: 'auto' }}>
                    <MyCheckbox
                        label={label}
                        checked={checked}
                        onChange={onChange}
                    />    
                </Box>
            </Box>
        </Box>
    )
}                



const TemplateTarefas = ({
    tipoTarefa = null,
    titulo = 'Acompanhamento de Tarefas',
}) => {

    const isMounted = useRef(false);
    const states = useTarefaState(tipoTarefa)
    const navigate = useNavigate()
    const [mapa, setMapa] = useState({open: false, latitude:null, longitude:null})
    const [openModalFinaliza, setOpenModalFinaliza] = useState(0);    
    const {permissaoUsuario} = useContext(AuthContext); /* permissão para telas*/    

    /* permissão para telas*/
    useEffect(()=>{
        if (permissaoTelas(permissaoUsuario, TELA_ACOES.Consultar,  PAGINA)){
            if (!isMounted.current) {
                isMounted.current = true
                states.submit.set()
            }
        }
        else {
            navigate('/gestor/dashboard')
        }

    }, [])


    useEffect(()=>{
        if (states.pesquisa.value === ''){
            states.submit.set()
        }
    }, [states.pesquisa.value,
        states.semSaida.value
        ])

    const onFiltroChange = (checked) => {
        states.semSaida.set(checked);
    }    
        
    const columns = [
        {field:'name', headerName:'Local Tarefa', flex: 1},
        {field:'posto', headerName:'Posto', flex: 1},       
        {field:'usuario', headerName:'Usuário', flex: 1},           
        {field:'Tipo', headerName:'IN / OUT', width: 110,
            renderCell: (cellValues) => { 
                if (cellValues.row.saida){
                return (
                    <span style={{color: 'green'}}>CHECK-OUT</span>
                )
                } else if (cellValues.row.entrada){
                    return (
                        <span style={{color: 'red'}}>CHECK-IN</span>
                    )
                }
            }
        },                   
        {field:'tipo', headerName:'Formulário Selecionado', flex: 1},  
        {field:'', headerName:'Status', width: 150, renderCell: (cellValues) => {
            const status = cellValues.row.saida ? 'Realizado' : 'Pendente';
            const color = cellValues.row.saida ? cellValues.row.descricao ? 'warning':'success' : 'error'; // Define a cor
            return (
                <Tooltip title={cellValues.row.descricao ? 'Realizado manual: '+cellValues.row.descricao : ''} placement="bottom" arrow>
                        <Fab
                            variant="extended"
                            size="small" 
                            color={color}
                            sx={{padding: '8px 20px', fontSize: '15px', height: '22px', zIndex: 0, position: 'absolute', 
                            }}
                        >
                            {status}
                        </Fab>
                </Tooltip>
            )
        }},              
        {field:'entrada', headerName:'Entrada', width: 150},
        {field:'saida', headerName:'Saida', width: 150},        
        {field:' ', headerName:'Ações', width:110, renderCell: (cellValues) =>{
            return (
                <>
                    <Tooltip title="Finalizar tarefa manualmente" placement="bottom" arrow>
                            <Button onClick={() => setOpenModalFinaliza(cellValues.row.id)} 
                                    sx={{width:'55px', padding: 0,minWidth:0}}
                                    disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Finalizar,  PAGINA)||cellValues.row.saida}
                                    ><AssignmentTurnedInIcon/>
                            </Button>
                    </Tooltip>                
                    <Tooltip title="Visualizar" placement="bottom" arrow>
                            <Button onClick={()=>navigate(
                                `/gestor/tarefas/formulario/${cellValues.row.id}${tipoTarefa
                                    ? `?origem=veiculos&tipotarefa=${encodeURIComponent(tipoTarefa)}`
                                    : ''}`
                            )} 
                                    sx={{width:'55px', padding: 0,minWidth:0}}
                                    disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Consultar,  PAGINA)||!cellValues.row.saida}
                                    ><ListAltIcon />
                            </Button>
                    </Tooltip>
                    <Tooltip title="Localização" placement="bottom" arrow>                    
                            <Button onClick={()=>setMapa({open:true, latitude:cellValues.row.latitude, longitude:cellValues.row.longitude})} 
                                    sx={{width:'55px', padding: 0,minWidth:0}}
                                    disabled={!permissaoTelas(permissaoUsuario, TELA_ACOES.Geolocalização,  PAGINA)}
                                    ><FmdGoodIcon />
                            </Button>
                    </Tooltip>                    
                </>
                
            )
        }}
    ]

    const onFinalizar = async (data) => {
        await states.finalizarTarefa.set(openModalFinaliza, data)
        setOpenModalFinaliza(0)

    }

    return (
   
        <Application>
            <> 
                <PaginationGridView 
                    title={titulo} 
                    states={states}
                    rows={states.tarefa.value}
                    columns={columns}
                    urlAdd={null}
                    urlVoltar={'/gestor/dashboard'}                    
                    onClickPesquisa={() => {
                        states.pagination.setPage(0);
                        states.submit.set(1); 
                    }}
                    nomeItem='Tarefa'
                    children={null}
                    modalAdd={null}
                    filtro={
                        <MyFiltro               
                            label='Filtra tarefas pendentes' 
                            checked={states.semSaida.value} 
                            states = {states}
                            onChange={(event) => onFiltroChange(event.target.checked)}
                            onClick={()=>{states.submit.set()}}
                            />
                    }
                />
                <MyMapModal mapa={{set:setMapa, value: mapa}} />
                <ModalFinalizaTarefa open={openModalFinaliza > 0} onClose={() => setOpenModalFinaliza(0)} onFinalizar={onFinalizar}/>
            </>
        </Application>
   
    )
}

export default TemplateTarefas;
